module.exports = __webpack_public_path__ + "static/media/tag-cisco-logo.5558e668.svg";